import { TextField, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MotivoFalla = {
    id: number;
    codigo: string;
    descripcion: string;
};

type MotivoFallaSelectorProps = {
    idMotivoFallaVisita: number | null;
    motivosFallaOptions: MotivoFalla[];
    loadingMotivosFalla: boolean;
    disabled?: boolean;
    onChangeMotivo: (idMotivoFallaVisita: number | null) => void;
};

const MotivoFallaSelector = ({
    idMotivoFallaVisita,
    motivosFallaOptions,
    loadingMotivosFalla,
    disabled = false,
    onChangeMotivo
}: MotivoFallaSelectorProps) => {
    const { t } = useTranslation('visitas');

    return (
        <TextField
            select
            fullWidth
            label={t('newVisit.label.failedVisitReason')}
            name="idMotivoFallaVisita"
            value={idMotivoFallaVisita ?? ''}
            onChange={(event) => onChangeMotivo(Number(event.target.value))}
            disabled={disabled || loadingMotivosFalla}
            error={idMotivoFallaVisita === null}
        >
            {loadingMotivosFalla ? (
                <MenuItem disabled value="">
                    {t('common.loading')}
                </MenuItem>
            ) : (
                motivosFallaOptions.map((motivo) => (
                    <MenuItem key={motivo.id} value={motivo.id}>
                        {motivo.descripcion}
                    </MenuItem>
                ))
            )}
        </TextField>
    );
};

export default MotivoFallaSelector;
